import CreateEventContainer from "../containers/CreateEventContainer";

const CreateEventPage = () => {
  return (
    <CreateEventContainer />
  );
};

export default CreateEventPage;
